/** Defaults for anonymous catalog browsing; protected financial queries opt into fresh reads. */
export const publicContentOptions = {
  staleTime: 60_000,
  refetchOnWindowFocus: false,
} as const;

export const protectedContentOptions = {
  staleTime: 0,
  gcTime: 0,
  retry: false,
  refetchOnWindowFocus: 'always',
  refetchOnReconnect: 'always',
} as const;
